import { render, staticRenderFns } from "./SearchFacet.vue?vue&type=template&id=48f22714&lang=pug&"
import script from "./SearchFacet.vue?vue&type=script&lang=js&"
export * from "./SearchFacet.vue?vue&type=script&lang=js&"
import style0 from "./SearchFacet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports